module.exports = __webpack_public_path__ + "assets/img/ic-shoe2.047ccd99.svg";